/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { CardBody } from "../../../../components/page-skeleton/CardBody";
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import { PageWrapper } from "../../../../components/page-skeleton/PageWrapper";
import { EmptyState } from "../../../../components/EmptyState";
import { Divider } from "../../../../components/Divider";
import { ButtonInternalLink } from "../../../../components/NewButtons";
import { routes } from "../../../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";
import { ProductGroupListItem } from "../models/ProductGroup";
import { ProductGroupsTable } from "./ProductGroupsTable";
import { PageFooter } from "../../../../components/page-skeleton/PageFooter";
import { StyledText } from "../../../../assets/typography/typography";

const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

type Props = {
  productGroups: ProductGroupListItem[];
};

export const ProductGroupsList = ({ productGroups }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  return (
    <PageWrapper>
      <CardContainer>
        <PageHeader
          title="Product groups"
          subtitle="Manage all of your product groups"
        >
          <ButtonInternalLink to={routes.productGroupNew(organizationKeyName)}>
            Create new product group
          </ButtonInternalLink>
        </PageHeader>
        {productGroups.length === 0 ? (
          <>
            <Divider />
            <CardBody additionalStyles={cardBodyAdditionalStyling}>
              <EmptyState
                title="No product groups created yet"
                subtitle="Click in the top right corner to create your first product group."
              />
            </CardBody>
          </>
        ) : (
          <div>
            <ProductGroupsTable productGroups={productGroups} />
            <PageFooter>
              <StyledText className="bodyTextRegular mb-0">
                {productGroups.length}{" "}
                {productGroups.length === 1
                  ? "product group"
                  : "product groups"}{" "}
                in total
              </StyledText>
            </PageFooter>
          </div>
        )}
      </CardContainer>
    </PageWrapper>
  );
};
